import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Attachment\UndoDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/UndoDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}/undo-delete'
*/
const UndoDeleteDossierAttachmentController = (args: { dossier: string | number | { id: string | number }, media: string | number } | [dossier: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UndoDeleteDossierAttachmentController.url(args, options),
    method: 'get',
})

UndoDeleteDossierAttachmentController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/attachment/{media}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Attachment\UndoDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/UndoDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}/undo-delete'
*/
UndoDeleteDossierAttachmentController.url = (args: { dossier: string | number | { id: string | number }, media: string | number } | [dossier: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        media: args.media,
    }

    return UndoDeleteDossierAttachmentController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Attachment\UndoDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/UndoDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}/undo-delete'
*/
UndoDeleteDossierAttachmentController.get = (args: { dossier: string | number | { id: string | number }, media: string | number } | [dossier: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UndoDeleteDossierAttachmentController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Attachment\UndoDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/UndoDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}/undo-delete'
*/
UndoDeleteDossierAttachmentController.head = (args: { dossier: string | number | { id: string | number }, media: string | number } | [dossier: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: UndoDeleteDossierAttachmentController.url(args, options),
    method: 'head',
})

export default UndoDeleteDossierAttachmentController